import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PETITION_PAGE_CONTACT_DM = createFcmDetails('petition_page_contact_dm', {
	owner: 'Campaign Squad',
	context: 'Contact DM CTAs',
	description:
		'Currently English feature, US only. Determines whether to enable certain methods to contact DMs, if contact info is available',
	template: {
		emailEnabled: false,
		phoneEnabled: false,
		emailSubjectLine: 'Subject line here',
		emailBody: ['Dear DM', 'Please respond', 'Best regards'],
	},
	import: false,
});
